import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AccessDenied from "./app/modules/AccessDenied/container";
import { Provider } from "react-redux";
import { store, persistor } from "~/app/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Router from "~/app/router";
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Switch>
            <Route path="/access-denied" component={AccessDenied} />
            <Route component={Router} />
          </Switch>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
